// extracted by mini-css-extract-plugin
module.exports = {"disclaimerHeading":"QuoteResults_disclaimerHeading__4kAnn"};